module.exports = __webpack_public_path__ + "img/shiangjuu_banner.f6d53ed0.jpg";